import { showError, showSuccess } from "common/ToastNotifications";
import LoadingOverlay from "components/atoms/LoadingOverlay";
import { MessageBox } from "components/atoms/MessageBox";
import OkCancelConfirmationBox from "components/molecules/OkCancelConfirmationBox";
import ProhibitedArea from "components/molecules/ProhibitedArea";
import SystemConnectionItems from "components/molecules/SystemConnectionItems";
import ManageSystemConnectionAwsS3 from "components/organisms/ManageSystemConnectionAwsS3";
import ManageSystemConnectionHubSpot from "components/organisms/ManageSystemConnectionHubSpot";
import ManageSystemConnectionJdbcPostgresql from "components/organisms/ManageSystemConnectionJdbcPostgresql";
import ManageSystemConnectionSalesforce from "components/organisms/ManageSystemConnectionSalesforce";
import ManageSystemConnectionSnowflake from "components/organisms/ManageSystemConnectionSnowflake";
import SystemConnectionList from "components/organisms/SystemConnectionList";
import AppPaths from "constants/appPaths";
import SystemConnectionSnowflakeTables from "containers/SystemConnectionSnowflakeTables";
import flatten from "flat";
import _ from "lodash";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";
import SystemConnectionAudit from "./SystemConnectionAudit";

const getConnectionType = (type) => {
    if (type === "aws_s3") {
        return "awss3";
    } else if (type === "jdbc") {
        return "jdbc";
    } else if (type === "snowflake") {
        return "snowflake";
    } else if (type === "salesforce") {
        return "salesforce";
    } else if (type === "hubspot") {
        return "hubspot";
    }
};

class SystemConnections extends Component {
    constructor(props) {
        super(props);
        this.state = {
            busy: false,
            busyMessage: "",
            permissionDenied: false,
            fetchingPermission: true,
            showSystemConnectionOptions: false,
        };
    }

    componentWillMount() {
        this.showBreadCrumbNavigationItems();
        this.props.getSystemConnectionPermission();
        if (!this.props.action) {
            this.setState({
                busy: true,
                busyMessage: "Getting connections...",
                fetchingConnections: true,
            });
            this.props.getSystemConnections();
        } else {
            if (this.props.connectionId) {
                if (this.props.connectionType === "awss3") {
                    this.props.getAwsS3Connection(this.props.connectionId);
                } else if (this.props.connectionType === "jdbc") {
                    this.props.getJdbcConnection(this.props.connectionId);
                } else if (this.props.connectionType === "snowflake") {
                    this.props.getSnowflakeConnection(this.props.connectionId);
                } else if (this.props.connectionType === "salesforce") {
                    this.props.getSalesforceConnection(this.props.connectionId);
                } else if (this.props.connectionType === "hubspot") {
                    this.props.getHubspotConnection(this.props.connectionId);
                }
            }
            if (this.props.action === "view" || this.props.action === "edit") {
                this.setState({
                    busy: true,
                    busyMessage: "Getting connection...",
                    fetchingConnection: true,
                });
            } else if (this.props.action === "history") {
                this.setState({
                    showHistory: false,
                    busy: true,
                    fetchingConnection: true,
                });
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetSystemConnectionsResultUpdate(prevProps);

        this.onCreateConnectionResultUpdate(prevProps);

        this.onGetConnectionResultUpdate(prevProps);

        this.onUpdateConnectionResultUpdate(prevProps);

        this.onDeleteConnectionResultUpdate(prevProps);

        this.onGetSystemConnectionPermissionResultUpdate(prevProps);

        this.onCreateSalesforceConnectionResultUpdate(prevProps);
        this.onGetSalesforceConnectionResultUpdate(prevProps);
        this.onUpdateSalesforceConnectionResultUpdate(prevProps);
        this.onDeleteSalesforceConnectionResultUpdate(prevProps);
        this.onStartSalesforceOAuthResultUpdate(prevProps);

        this.onCreateHubspotConnectionResultUpdate(prevProps);
        this.onGetHubspotConnectionResultUpdate(prevProps);
        this.onUpdateHubspotConnectionResultUpdate(prevProps);
        this.onDeleteHubspotConnectionResultUpdate(prevProps);
        this.onStartHubspotOAuthResultUpdate(prevProps);
    }

    onGetSystemConnectionsResultUpdate = (prevProps) => {
        if (this.props.getSystemConnectionsResult && this.props.getSystemConnectionsResult !== prevProps.getSystemConnectionsResult) {
            if (!this.props.getSystemConnectionsResult.success) {
                if (this.props.getSystemConnectionsResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Unable to get connections at this moment.");
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingConnections: false,
            });
        }
    };

    onCreateConnectionResultUpdate = (prevProps) => {
        // For AWS S3
        if (this.props.createConnectionResult && this.props.createConnectionResult !== prevProps.createConnectionResult) {
            if (!this.props.createConnectionResult.success) {
                showError(this.props.createConnectionResult.message || "Connection cannot be created at this moment.");
                this.setState({
                    busy: false,
                    manageConnectionErrors: this.props.createConnectionResult.fields,
                });
            } else {
                showSuccess("Connection created successfully.", () => {
                    this.props.history.push(
                        AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                            ":configurationItem",
                            this.props.match.params.configurationItem.toLowerCase(),
                        ),
                    );
                });
            }
        }

        // For JDBC
        if (this.props.createJdbcConnectionResult && this.props.createJdbcConnectionResult !== prevProps.createJdbcConnectionResult) {
            if (!this.props.createJdbcConnectionResult.success) {
                showError(this.props.createJdbcConnectionResult.message || "Connection cannot be created at this moment.");
                this.setState({
                    busy: false,
                    manageConnectionErrors: this.props.createJdbcConnectionResult.fields,
                });
            } else {
                showSuccess("Connection created successfully.", () => {
                    this.props.history.push(
                        AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                            ":configurationItem",
                            this.props.match.params.configurationItem.toLowerCase(),
                        ),
                    );
                });
            }
        }

        if (this.props.createSnowflakeConnectionResult && this.props.createSnowflakeConnectionResult !== prevProps.createSnowflakeConnectionResult) {
            if (!this.props.createSnowflakeConnectionResult.success) {
                showError(this.props.createSnowflakeConnectionResult.message || "Connection cannot be created at this moment.");
                this.setState({
                    busy: false,
                    manageConnectionErrors: this.props.createSnowflakeConnectionResult.fields,
                });
            } else {
                showSuccess("Connection created successfully.", () => {
                    this.props.history.push(
                        AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                            ":configurationItem",
                            this.props.match.params.configurationItem.toLowerCase(),
                        ),
                    );
                });
            }
        }
    };

    onGetConnectionResultUpdate = (prevProps) => {
        // For AWS S3
        if (this.props.getConnectionResult && this.props.getConnectionResult !== prevProps.getConnectionResult) {
            if (!this.props.getConnectionResult.success) {
                if (this.props.getConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Unable to get connection.");
                }
            } else {
                if (this.props.action === "history") {
                    this.setState({
                        showHistory: true,
                    });
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingConnection: false,
            });
            if (this.props.systemConnectionListResult.Items.length === 0) {
                this.showBreadCrumbNavigationItems();
            }
        }

        // For JDBC
        if (this.props.getJdbcConnectionResult && this.props.getJdbcConnectionResult !== prevProps.getJdbcConnectionResult) {
            if (!this.props.getJdbcConnectionResult.success) {
                if (this.props.getJdbcConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Unable to get connection.");
                }
            } else {
                if (this.props.action === "history") {
                    this.setState({
                        showHistory: true,
                    });
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingConnection: false,
            });
            if (this.props.systemConnectionListResult.Items.length === 0) {
                this.showBreadCrumbNavigationItems();
            }
        }

        if (this.props.getSnowflakeConnectionResult && this.props.getSnowflakeConnectionResult !== prevProps.getSnowflakeConnectionResult) {
            if (!this.props.getSnowflakeConnectionResult.success) {
                if (this.props.getSnowflakeConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Unable to get connection.");
                }
            } else {
                if (this.props.action === "history") {
                    this.setState({
                        showHistory: true,
                    });
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingConnection: false,
            });
            if (this.props.systemConnectionListResult.Items.length === 0) {
                this.showBreadCrumbNavigationItems();
            }
        }
    };

    onUpdateConnectionResultUpdate = (prevProps) => {
        // For AWS S3
        if (this.props.updateConnectionResult && this.props.updateConnectionResult !== prevProps.updateConnectionResult) {
            if (!this.props.updateConnectionResult.success) {
                if (this.props.updateConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        busy: false,
                        permissionDenied: true,
                    });
                } else {
                    this.setState({
                        busy: false,
                        manageConnectionErrors: this.props.updateConnectionResult.fields,
                    });
                    showError("Unable to update connection.");
                }
            } else {
                if (this.state.isActivateDeactivateConnection) {
                    showSuccess(`Connection ${this.state.connectionActive ? "activated" : "deactivated"} successfully.`);
                    this.setState({
                        busy: false,
                        isActivateDeactivateConnection: false,
                        connectionActive: false,
                    });
                } else {
                    this.setState({
                        busyMessage: "Connection updated. Please wait...",
                    });
                    showSuccess("Connection updated successfully.", () => {
                        this.props.history.push(
                            AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                                ":configurationItem",
                                this.props.match.params.configurationItem.toLowerCase(),
                            ),
                        );
                    });
                }
            }
        }

        // For JDBC
        if (this.props.updateJdbcConnectionResult && this.props.updateJdbcConnectionResult !== prevProps.updateJdbcConnectionResult) {
            if (!this.props.updateJdbcConnectionResult.success) {
                if (this.props.updateJdbcConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        busy: false,
                        permissionDenied: true,
                    });
                } else {
                    this.setState({
                        busy: false,
                        manageConnectionErrors: this.props.updateJdbcConnectionResult.fields,
                    });
                    showError("Unable to update connection.");
                }
            } else {
                if (this.state.isActivateDeactivateConnection) {
                    showSuccess(`Connection ${this.state.connectionActive ? "activated" : "deactivated"} successfully.`);
                    this.setState({
                        busy: false,
                        isActivateDeactivateConnection: false,
                        connectionActive: false,
                    });
                } else {
                    this.setState({
                        busyMessage: "Connection updated. Please wait...",
                    });
                    showSuccess("Connection updated successfully.", () => {
                        this.props.history.push(
                            AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                                ":configurationItem",
                                this.props.match.params.configurationItem.toLowerCase(),
                            ),
                        );
                    });
                }
            }
        }

        if (this.props.updateSnowflakeConnectionResult && this.props.updateSnowflakeConnectionResult !== prevProps.updateSnowflakeConnectionResult) {
            if (!this.props.updateSnowflakeConnectionResult.success) {
                if (this.props.updateSnowflakeConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        busy: false,
                        permissionDenied: true,
                    });
                } else {
                    this.setState({
                        busy: false,
                        manageConnectionErrors: this.props.updateSnowflakeConnectionResult.fields,
                    });
                    showError("Unable to update connection.");
                }
            } else {
                if (this.state.isActivateDeactivateConnection) {
                    showSuccess(`Connection ${this.state.connectionActive ? "activated" : "deactivated"} successfully.`);
                    this.setState({
                        busy: false,
                        isActivateDeactivateConnection: false,
                        connectionActive: false,
                    });
                } else {
                    this.setState({
                        busyMessage: "Connection updated. Please wait...",
                    });
                    showSuccess("Connection updated successfully.", () => {
                        this.props.history.push(
                            AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                                ":configurationItem",
                                this.props.match.params.configurationItem.toLowerCase(),
                            ),
                        );
                    });
                }
            }
        }
    };

    onDeleteConnectionResultUpdate = (prevProps) => {
        // For AWS S3
        if (this.props.deleteConnectionResult && this.props.deleteConnectionResult !== prevProps.deleteConnectionResult) {
            if (!this.props.deleteConnectionResult.success) {
                showError(this.props.deleteConnectionResult.message || "Connection cannot be deleted.");
            } else {
                showSuccess("Connection deleted successfully.");
            }
            this.setState({
                busy: false,
            });
        }

        // For JDBC
        if (this.props.deleteJdbcConnectionResult && this.props.deleteJdbcConnectionResult !== prevProps.deleteJdbcConnectionResult) {
            if (!this.props.deleteJdbcConnectionResult.success) {
                showError(this.props.deleteJdbcConnectionResult.message || "Connection cannot be deleted.");
            } else {
                showSuccess("Connection deleted successfully.");
            }
            this.setState({
                busy: false,
            });
        }

        if (this.props.deleteSnowflakeConnectionResult && this.props.deleteSnowflakeConnectionResult !== prevProps.deleteSnowflakeConnectionResult) {
            if (!this.props.deleteSnowflakeConnectionResult.success) {
                showError(this.props.deleteSnowflakeConnectionResult.message || "Connection cannot be deleted.");
            } else {
                showSuccess("Connection deleted successfully.");
            }
            this.setState({
                busy: false,
            });
        }
    };

    onGetSystemConnectionPermissionResultUpdate = (prevProps) => {
        if (this.props.getSystemConnectionPermissionResult && this.props.getSystemConnectionPermissionResult !== prevProps.getSystemConnectionPermissionResult) {
            if (!this.props.getSystemConnectionPermissionResult.success || !this.props.permission || !this.props.permission.canView) {
                this.setState({
                    permissionDenied: true,
                });
            }
            this.setState({
                fetchingPermission: false,
            });
        }
    };

    onCreateSalesforceConnectionResultUpdate = (prevProps) => {
        if (this.props.createSalesforceConnectionResult && this.props.createSalesforceConnectionResult !== prevProps.createSalesforceConnectionResult) {
            if (!this.props.createSalesforceConnectionResult.success) {
                showError(this.props.createSalesforceConnectionResult.message || "Connection cannot be created at this moment.");
                this.setState({
                    busy: false,
                    manageConnectionErrors: this.props.createSalesforceConnectionResult.fields,
                });
            } else {
                let returnPath = AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                    ":configurationItem",
                    this.props.match.params.configurationItem.toLowerCase(),
                );
                let returnUrl = window.location.origin + returnPath;
                this.setState({
                    busyMessage: "Initiating Salesforce OAuth...",
                });
                this.props.startSalesforceOAuth(this.props.createdSalesforceConnection.connectionId, returnUrl);
            }
        }
    };

    onGetSalesforceConnectionResultUpdate = (prevProps) => {
        if (this.props.getSalesforceConnectionResult && this.props.getSalesforceConnectionResult !== prevProps.getSalesforceConnectionResult) {
            if (!this.props.getSalesforceConnectionResult.success) {
                if (this.props.getSalesforceConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({ permissionDenied: true });
                } else {
                    showError("Unable to get connection.");
                }
            } else {
                if (this.props.action === "history") {
                    this.setState({ showHistory: true });
                }
            }
            this.setState({ busy: false, busyMessage: "", fetchingConnection: false });
            if (this.props.systemConnectionListResult.Items.length === 0) {
                this.showBreadCrumbNavigationItems();
            }
        }
    };

    onUpdateSalesforceConnectionResultUpdate = (prevProps) => {
        if (this.props.updateSalesforceConnectionResult && this.props.updateSalesforceConnectionResult !== prevProps.updateSalesforceConnectionResult) {
            if (!this.props.updateSalesforceConnectionResult.success) {
                if (this.props.updateSalesforceConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({ busy: false, permissionDenied: true });
                } else {
                    this.setState({ busy: false, manageConnectionErrors: this.props.updateSalesforceConnectionResult.fields });
                    showError("Unable to update connection.");
                }
            } else {
                if (this.state.isActivateDeactivateConnection) {
                    showSuccess(`Connection ${this.state.connectionActive ? "activated" : "deactivated"} successfully.`);
                    this.setState({ busy: false, isActivateDeactivateConnection: false, connectionActive: false });
                } else {
                    let returnPath = AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                        ":configurationItem",
                        this.props.match.params.configurationItem.toLowerCase(),
                    );
                    let returnUrl = window.location.origin + returnPath;
                    this.setState({ busyMessage: "Initiating Salesforce OAuth..." });
                    this.props.startSalesforceOAuth(this.props.salesforceConnection.connectionId, returnUrl);
                }
            }
        }
    };

    onDeleteSalesforceConnectionResultUpdate = (prevProps) => {
        if (this.props.deleteSalesforceConnectionResult && this.props.deleteSalesforceConnectionResult !== prevProps.deleteSalesforceConnectionResult) {
            if (!this.props.deleteSalesforceConnectionResult.success) {
                showError(this.props.deleteSalesforceConnectionResult.message || "Connection cannot be deleted.");
            } else {
                showSuccess("Connection deleted successfully.");
            }
            this.setState({ busy: false });
        }
    };

    onStartSalesforceOAuthResultUpdate = (prevProps) => {
        if (this.props.startSalesforceOAuthResult && this.props.startSalesforceOAuthResult !== prevProps.startSalesforceOAuthResult) {
            if (!this.props.startSalesforceOAuthResult.success) {
                showError(this.props.startSalesforceOAuthResult.message || "Unable to initiate Salesforce authentication.");
                this.setState({ busy: false });
            } else {
                window.location.href = this.props.startSalesforceOAuthResult.data.authUrl;
            }
        }
    };

    onCreateHubspotConnectionResultUpdate = (prevProps) => {
        if (this.props.createHubspotConnectionResult && this.props.createHubspotConnectionResult !== prevProps.createHubspotConnectionResult) {
            if (!this.props.createHubspotConnectionResult.success) {
                showError(this.props.createHubspotConnectionResult.message || "Connection cannot be created at this moment.");
                this.setState({
                    busy: false,
                    manageConnectionErrors: this.props.createHubspotConnectionResult.fields,
                });
            } else {
                let returnPath = AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                    ":configurationItem",
                    this.props.match.params.configurationItem.toLowerCase(),
                );
                let returnUrl = window.location.origin + returnPath;
                this.setState({
                    busyMessage: "Initiating HubSpot OAuth...",
                });
                this.props.startHubspotOAuth(this.props.createdHubspotConnection.connectionId, returnUrl);
            }
        }
    };

    onGetHubspotConnectionResultUpdate = (prevProps) => {
        if (this.props.getHubspotConnectionResult && this.props.getHubspotConnectionResult !== prevProps.getHubspotConnectionResult) {
            if (!this.props.getHubspotConnectionResult.success) {
                if (this.props.getHubspotConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({ permissionDenied: true });
                } else {
                    showError("Unable to get connection.");
                }
            } else {
                if (this.props.action === "history") {
                    this.setState({ showHistory: true });
                }
            }
            this.setState({ busy: false, busyMessage: "", fetchingConnection: false });
            if (this.props.systemConnectionListResult.Items.length === 0) {
                this.showBreadCrumbNavigationItems();
            }
        }
    };

    onUpdateHubspotConnectionResultUpdate = (prevProps) => {
        if (this.props.updateHubspotConnectionResult && this.props.updateHubspotConnectionResult !== prevProps.updateHubspotConnectionResult) {
            if (!this.props.updateHubspotConnectionResult.success) {
                if (this.props.updateHubspotConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({ busy: false, permissionDenied: true });
                } else {
                    this.setState({ busy: false, manageConnectionErrors: this.props.updateHubspotConnectionResult.fields });
                    showError("Unable to update connection.");
                }
            } else {
                if (this.state.isActivateDeactivateConnection) {
                    showSuccess(`Connection ${this.state.connectionActive ? "activated" : "deactivated"} successfully.`);
                    this.setState({ busy: false, isActivateDeactivateConnection: false, connectionActive: false });
                } else {
                    let returnPath = AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                        ":configurationItem",
                        this.props.match.params.configurationItem.toLowerCase(),
                    );
                    let returnUrl = window.location.origin + returnPath;
                    this.setState({ busyMessage: "Initiating HubSpot OAuth..." });
                    this.props.startHubspotOAuth(this.props.hubspotConnection.connectionId, returnUrl);
                }
            }
        }
    };

    onDeleteHubspotConnectionResultUpdate = (prevProps) => {
        if (this.props.deleteHubspotConnectionResult && this.props.deleteHubspotConnectionResult !== prevProps.deleteHubspotConnectionResult) {
            if (!this.props.deleteHubspotConnectionResult.success) {
                showError(this.props.deleteHubspotConnectionResult.message || "Connection cannot be deleted.");
            } else {
                showSuccess("Connection deleted successfully.");
            }
            this.setState({ busy: false });
        }
    };

    onStartHubspotOAuthResultUpdate = (prevProps) => {
        if (this.props.startHubspotOAuthResult && this.props.startHubspotOAuthResult !== prevProps.startHubspotOAuthResult) {
            if (!this.props.startHubspotOAuthResult.success) {
                showError(this.props.startHubspotOAuthResult.message || "Unable to initiate HubSpot authentication.");
                this.setState({ busy: false });
            } else {
                window.location.href = this.props.startHubspotOAuthResult.data.authUrl;
            }
        }
    };

    showBreadCrumbNavigationItems = () => {
        if (this.props.showSubBreadCrumbNavigationItems) {
            let breadCrumbItems = [];
            if (this.props.connectionType) {
                breadCrumbItems.push({
                    route: "",
                    text: this.props.connectionType,
                });
            }
            if (this.props.action) {
                let connectionName = "";
                switch (this.props.action.toLowerCase()) {
                    case "create":
                        breadCrumbItems.push({
                            route: "",
                            text: "New connection",
                        });
                        break;
                    case "view":
                    case "edit":
                        connectionName = this.getConnectionName();
                        breadCrumbItems.push(
                            ...[
                                {
                                    route: "",
                                    text: connectionName,
                                },
                            ],
                        );
                        break;
                    case "history":
                        connectionName = this.getConnectionName();
                        breadCrumbItems.push(
                            ...[
                                {
                                    route: "",
                                    text: connectionName,
                                },
                                {
                                    route: "",
                                    text: "History",
                                },
                            ],
                        );
                        break;
                    case "tables":
                        connectionName = this.getConnectionName();
                        breadCrumbItems.push(
                            ...[
                                {
                                    route: "",
                                    text: connectionName,
                                },
                                {
                                    route: "",
                                    text: "Tables & Schema",
                                },
                            ],
                        );
                        break;
                    default:
                }
            }

            this.props.showSubBreadCrumbNavigationItems(breadCrumbItems);
        }
    };

    getConnectionName = () => {
        let name = this.props.connectionId;
        if (this.props.systemConnectionListResult.Items && this.props.systemConnectionListResult.Items.length > 0) {
            let connection = this.props.systemConnectionListResult.Items.find((item) => item.connectionId === this.props.connectionId);
            if (connection) {
                name = connection.name;
            }
        } else if (this.props.connection && this.props.connection.connectionId === this.props.connectionId) {
            name = this.props.connection.name;
        }
        return name;
    };

    showAddConnection = () => {
        this.setState({
            showSystemConnectionOptions: true,
        });
    };

    showEditConnection = (connectionId, connectionType) => {
        this.props.history.push(
            AppPaths.TENANT_CONFIGURATION_ITEM_SUB_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                .replace(":subItem", getConnectionType(connectionType))
                .replace(":itemId", connectionId)
                .replace(":itemAction", "edit"),
        );
    };

    showViewConnection = (connectionId, connectionType) => {
        this.props.history.push(
            AppPaths.TENANT_CONFIGURATION_ITEM_SUB_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                .replace(":subItem", getConnectionType(connectionType))
                .replace(":itemId", connectionId)
                .replace(":itemAction", "view"),
        );
    };

    showConnectionHistory = (connectionId, connectionType) => {
        this.props.history.push(
            AppPaths.TENANT_CONFIGURATION_ITEM_SUB_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                .replace(":subItem", getConnectionType(connectionType))
                .replace(":itemId", connectionId)
                .replace(":itemAction", "history"),
        );
    };

    showTablesConnection = (connectionId, connectionType) => {
        this.props.history.push(
            AppPaths.TENANT_CONFIGURATION_ITEM_SUB_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                .replace(":subItem", getConnectionType(connectionType))
                .replace(":itemId", connectionId)
                .replace(":itemAction", "tables"),
        );
    };

    cancelCreateConnection = () => {
        this.props.history.push(
            AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                ":configurationItem",
                this.props.match.params.configurationItem.toLowerCase(),
            ),
        );
    };

    createConnection = (connection) => {
        this.setState({
            busy: true,
            busyMessage: "Creating connection...",
        });
        this.props.createAwsS3Connection(connection);
    };

    createJdbcConnection = (connection) => {
        this.setState({
            busy: true,
            busyMessage: "Creating connection...",
        });
        this.props.createJdbcConnection(connection);
    };

    createSnowflakeConnection = (connection) => {
        this.setState({
            busy: true,
            busyMessage: "Creating connection...",
        });
        this.props.createSnowflakeConnection(connection);
    };

    updateAwsS3Connection = (connectionId, updatedConnection) => {
        if (_.isEmpty(updatedConnection) === false) {
            this.setState({
                busy: true,
                busyMessage: "Updating connection...",
            });
            this.props.updateAwsS3Connection(connectionId, updatedConnection);
        } else {
            this.props.history.push(
                AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                    ":configurationItem",
                    this.props.match.params.configurationItem.toLowerCase(),
                ),
            );
        }
    };

    updateJdbcConnection = (connectionId, updatedConnection) => {
        if (_.isEmpty(updatedConnection) === false) {
            this.setState({
                busy: true,
                busyMessage: "Updating connection...",
            });
            this.props.updateJdbcConnection(connectionId, updatedConnection);
        } else {
            this.props.history.push(
                AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                    ":configurationItem",
                    this.props.match.params.configurationItem.toLowerCase(),
                ),
            );
        }
    };

    updateSnowflakeConnection = (connectionId, updatedConnection) => {
        if (_.isEmpty(updatedConnection) === false) {
            this.setState({
                busy: true,
                busyMessage: "Updating connection...",
            });
            this.props.updateSnowflakeConnection(connectionId, updatedConnection);
        } else {
            this.props.history.push(
                AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                    ":configurationItem",
                    this.props.match.params.configurationItem.toLowerCase(),
                ),
            );
        }
    };

    createSalesforceConnection = (connection) => {
        this.setState({ busy: true, busyMessage: "Creating connection..." });
        this.props.createSalesforceConnection(connection);
    };

    updateSalesforceConnection = (connectionId, updatedConnection) => {
        if (_.isEmpty(updatedConnection) === false) {
            this.setState({ busy: true, busyMessage: "Updating connection..." });
            this.props.updateSalesforceConnection(connectionId, updatedConnection);
        } else {
            this.props.history.push(
                AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                    ":configurationItem",
                    this.props.match.params.configurationItem.toLowerCase(),
                ),
            );
        }
    };

    createHubspotConnection = (connection) => {
        this.setState({ busy: true, busyMessage: "Creating connection..." });
        this.props.createHubspotConnection(connection);
    };

    updateHubspotConnection = (connectionId, updatedConnection) => {
        if (_.isEmpty(updatedConnection) === false) {
            this.setState({ busy: true, busyMessage: "Updating connection..." });
            this.props.updateHubspotConnection(connectionId, updatedConnection);
        } else {
            this.props.history.push(
                AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                    ":configurationItem",
                    this.props.match.params.configurationItem.toLowerCase(),
                ),
            );
        }
    };

    onActivateDeactivateConnection = (connection, active, connectionType) => {
        if (connectionType === "aws_s3") {
            this.setState({
                isActivateDeactivateConnection: true,
                connectionActive: active,
                busy: true,
                busyMessage: active ? "Activating connection..." : "Deactivating connection...",
            });
            this.props.updateAwsS3Connection(connection.connectionId, { version: connection.version, active });
        } else if (connectionType === "jdbc") {
            this.setState({
                isActivateDeactivateConnection: true,
                connectionActive: active,
                busy: true,
                busyMessage: active ? "Activating connection..." : "Deactivating connection...",
            });
            this.props.updateJdbcConnection(connection.connectionId, { version: connection.version, active });
        } else if (connectionType === "snowflake") {
            this.setState({
                isActivateDeactivateConnection: true,
                connectionActive: active,
                busy: true,
                busyMessage: active ? "Activating connection..." : "Deactivating connection...",
            });
            this.props.updateSnowflakeConnection(connection.connectionId, { version: connection.version, active });
        } else if (connectionType === "salesforce") {
            this.setState({
                isActivateDeactivateConnection: true,
                connectionActive: active,
                busy: true,
                busyMessage: active ? "Activating connection..." : "Deactivating connection...",
            });
            this.props.updateSalesforceConnection(connection.connectionId, { version: connection.version, active });
        } else if (connectionType === "hubspot") {
            this.setState({
                isActivateDeactivateConnection: true,
                connectionActive: active,
                busy: true,
                busyMessage: active ? "Activating connection..." : "Deactivating connection...",
            });
            this.props.updateHubspotConnection(connection.connectionId, { version: connection.version, active });
        }
    };

    onConnectionValuesChanged = (changedValues, allValues) => {
        if (_.isEmpty(this.state.manageConnectionErrors) === false) {
            let manageConnectionErrors = { ...this.state.manageConnectionErrors };
            let flatObject = flatten(changedValues);
            for (let key in flatObject) {
                delete manageConnectionErrors[key];
            }
            this.setState({
                manageConnectionErrors,
            });
        }
    };

    showDeleteConnectionConfirmation = (connection) => {
        this.setState({
            deletedConnection: connection,
            showConnectionDeleteConfirmation: true,
            deleteConnectionConfirmMessage: `Are you sure, you want to delete '${connection.name}' connection?`,
        });
    };

    onDeleteConnectionConfirmed = () => {
        if (this.state.deletedConnection.type === "aws_s3") {
            this.setState({
                busy: true,
                busyMessage: "Deleting connection...",
            });
            this.props.deleteAwsS3Connection(this.state.deletedConnection.connectionId);
        } else if (this.state.deletedConnection.type === "jdbc") {
            this.setState({
                busy: true,
                busyMessage: "Deleting connection...",
            });
            this.props.deleteJdbcConnection(this.state.deletedConnection.connectionId);
        } else if (this.state.deletedConnection.type === "snowflake") {
            this.setState({
                busy: true,
                busyMessage: "Deleting connection...",
            });
            this.props.deleteSnowflakeConnection(this.state.deletedConnection.connectionId);
        } else if (this.state.deletedConnection.type === "salesforce") {
            this.setState({ busy: true, busyMessage: "Deleting connection..." });
            this.props.deleteSalesforceConnection(this.state.deletedConnection.connectionId);
        } else if (this.state.deletedConnection.type === "hubspot") {
            this.setState({ busy: true, busyMessage: "Deleting connection..." });
            this.props.deleteHubspotConnection(this.state.deletedConnection.connectionId);
        }
        this.onDeleteConnectionCancel();
    };

    onDeleteConnectionCancel = () => {
        this.setState({
            deletedConnection: null,
            showConnectionDeleteConfirmation: false,
            deleteConnectionConfirmMessage: "",
        });
    };

    onItemClick = (item) => {
        this.setState({
            showSystemConnectionOptions: false,
        });
        switch (item) {
            case "aws_s3":
                this.props.history.push(
                    AppPaths.TENANT_CONFIGURATION_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                        .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                        .replace(":itemId", "awss3")
                        .replace(":itemAction", "create"),
                );
                break;
            case "jdbc":
                this.props.history.push(
                    AppPaths.TENANT_CONFIGURATION_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                        .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                        .replace(":itemId", "jdbc")
                        .replace(":itemAction", "create"),
                );
                break;
            case "snowflake":
                this.props.history.push(
                    AppPaths.TENANT_CONFIGURATION_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                        .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                        .replace(":itemId", "snowflake")
                        .replace(":itemAction", "create"),
                );
                break;
            case "salesforce":
                this.props.history.push(
                    AppPaths.TENANT_CONFIGURATION_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                        .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                        .replace(":itemId", "salesforce")
                        .replace(":itemAction", "create"),
                );
                break;
            case "hubspot":
                this.props.history.push(
                    AppPaths.TENANT_CONFIGURATION_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                        .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                        .replace(":itemId", "hubspot")
                        .replace(":itemAction", "create"),
                );
                break;
            default:
                this.props.history.push(
                    AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                        ":configurationItem",
                        this.props.match.params.configurationItem.toLowerCase(),
                    ),
                );
                break;
        }
    };

    isBusy = () => {
        let isBusy = this.state.busy || this.state.fetchingConnections || this.state.fetchingPermission;
        if (this.props.action === "view" || this.props.action === "edit") {
            isBusy = isBusy || this.state.fetchingConnection;
        }
        return isBusy;
    };

    getConnectionComponent = () => {
        if (this.state.permissionDenied) {
            return <ProhibitedArea></ProhibitedArea>;
        }
        if (this.state.showSystemConnectionOptions) {
            return <SystemConnectionItems onItemClick={this.onItemClick}></SystemConnectionItems>;
        }
        if (!this.props.action) {
            return (
                <>
                    <OkCancelConfirmationBox
                        show={this.state.showConnectionDeleteConfirmation}
                        message={this.state.deleteConnectionConfirmMessage}
                        onCancel={this.onDeleteConnectionCancel}
                        onOk={this.onDeleteConnectionConfirmed}
                    ></OkCancelConfirmationBox>
                    {!this.state.fetchingConnections ? (
                        <SystemConnectionList
                            permission={this.props.permission}
                            connectionList={this.props.systemConnectionListResult.Items}
                            onAddConnection={this.showAddConnection}
                            onViewConnection={this.showViewConnection}
                            onEditConnection={this.showEditConnection}
                            onDeleteConnection={this.showDeleteConnectionConfirmation}
                            onActivateDeactivateConnection={this.onActivateDeactivateConnection}
                            onViewConnectionHistory={this.showConnectionHistory}
                            onViewConnectionTables={this.showTablesConnection}
                        />
                    ) : (
                        <></>
                    )}
                </>
            );
        }
        if (this.props.connectionType === "awss3") {
            switch (this.props.action.toLowerCase()) {
                case "create":
                    return (
                        <ManageSystemConnectionAwsS3
                            permission={this.props.permission}
                            action={this.props.action}
                            onSave={this.createConnection}
                            onCancel={this.cancelCreateConnection}
                            formErrors={this.state.manageConnectionErrors}
                            onValuesChanged={this.onConnectionValuesChanged}
                        ></ManageSystemConnectionAwsS3>
                    );
                case "view":
                case "edit":
                    return !this.state.fetchingConnection ? (
                        this.props.connection ? (
                            <>
                                <OkCancelConfirmationBox
                                    show={this.state.showRegenerateSecretConfirmation}
                                    message={this.state.regenerateSecretConfirmationMessage}
                                    onCancel={this.onRegenerateSecretCancel}
                                    onOk={this.onRegenerateSecretConfirmed}
                                ></OkCancelConfirmationBox>
                                <ManageSystemConnectionAwsS3
                                    permission={this.props.permission}
                                    action={this.props.action}
                                    onSave={this.updateAwsS3Connection}
                                    onCancel={this.cancelCreateConnection}
                                    onRegenerateConnectionSecret={this.showRegenerateSecretConfirmation}
                                    connection={this.props.connection}
                                    formErrors={this.state.manageConnectionErrors}
                                    onValuesChanged={this.onConnectionValuesChanged}
                                ></ManageSystemConnectionAwsS3>
                            </>
                        ) : this.props.getConnectionResult.success ? (
                            <MessageBox floating size="big" header="Connection not found.">
                                <p>The app you are looking for does not exist.</p>
                            </MessageBox>
                        ) : (
                            <></>
                        )
                    ) : (
                        <></>
                    );
                case "history":
                    return this.state.showHistory ? (
                        <SystemConnectionAudit connection={this.props.connection} onClose={this.cancelCreateConnection}></SystemConnectionAudit>
                    ) : (
                        <></>
                    );
                default:
                    return <ProhibitedArea></ProhibitedArea>;
            }
        } else if (this.props.connectionType === "jdbc") {
            switch (this.props.action.toLowerCase()) {
                case "create":
                    return (
                        <ManageSystemConnectionJdbcPostgresql
                            permission={this.props.permission}
                            action={this.props.action}
                            onSave={this.createJdbcConnection}
                            onCancel={this.cancelCreateConnection}
                            formErrors={this.state.manageConnectionErrors}
                            onValuesChanged={this.onConnectionValuesChanged}
                        ></ManageSystemConnectionJdbcPostgresql>
                    );
                case "view":
                case "edit":
                    return !this.state.fetchingConnection ? (
                        this.props.jdbcConnection ? (
                            <>
                                <OkCancelConfirmationBox
                                    show={this.state.showRegenerateSecretConfirmation}
                                    message={this.state.regenerateSecretConfirmationMessage}
                                    onCancel={this.onRegenerateSecretCancel}
                                    onOk={this.onRegenerateSecretConfirmed}
                                ></OkCancelConfirmationBox>
                                <ManageSystemConnectionJdbcPostgresql
                                    permission={this.props.permission}
                                    action={this.props.action}
                                    onSave={this.updateJdbcConnection}
                                    onCancel={this.cancelCreateConnection}
                                    onRegenerateConnectionSecret={this.showRegenerateSecretConfirmation}
                                    connection={this.props.jdbcConnection}
                                    formErrors={this.state.manageConnectionErrors}
                                    onValuesChanged={this.onConnectionValuesChanged}
                                ></ManageSystemConnectionJdbcPostgresql>
                            </>
                        ) : this.props.getJdbcConnectionResult.success ? (
                            <MessageBox floating size="big" header="Connection not found.">
                                <p>The app you are looking for does not exist.</p>
                            </MessageBox>
                        ) : (
                            <></>
                        )
                    ) : (
                        <></>
                    );
                case "history":
                    return this.state.showHistory ? (
                        <SystemConnectionAudit connection={this.props.jdbcConnection} onClose={this.cancelCreateConnection}></SystemConnectionAudit>
                    ) : (
                        <></>
                    );
                default:
                    return <ProhibitedArea></ProhibitedArea>;
            }
        } else if (this.props.connectionType === "snowflake") {
            switch (this.props.action.toLowerCase()) {
                case "create":
                    return (
                        <ManageSystemConnectionSnowflake
                            permission={this.props.permission}
                            action={this.props.action}
                            onSave={this.createSnowflakeConnection}
                            onCancel={this.cancelCreateConnection}
                            formErrors={this.state.manageConnectionErrors}
                            onValuesChanged={this.onConnectionValuesChanged}
                        ></ManageSystemConnectionSnowflake>
                    );
                case "view":
                case "edit":
                    return !this.state.fetchingConnection ? (
                        this.props.snowflakeConnection ? (
                            <>
                                <OkCancelConfirmationBox
                                    show={this.state.showRegenerateSecretConfirmation}
                                    message={this.state.regenerateSecretConfirmationMessage}
                                    onCancel={this.onRegenerateSecretCancel}
                                    onOk={this.onRegenerateSecretConfirmed}
                                ></OkCancelConfirmationBox>
                                <ManageSystemConnectionSnowflake
                                    permission={this.props.permission}
                                    action={this.props.action}
                                    onSave={this.updateSnowflakeConnection}
                                    onCancel={this.cancelCreateConnection}
                                    connection={this.props.snowflakeConnection}
                                    formErrors={this.state.manageConnectionErrors}
                                    onValuesChanged={this.onConnectionValuesChanged}
                                ></ManageSystemConnectionSnowflake>
                            </>
                        ) : this.props.getSnowflakeConnectionResult.success ? (
                            <MessageBox floating size="big" header="Connection not found.">
                                <p>The app you are looking for does not exist.</p>
                            </MessageBox>
                        ) : (
                            <></>
                        )
                    ) : (
                        <></>
                    );
                case "tables":
                    return !this.state.fetchingConnection ? (
                        this.props.snowflakeConnection ? (
                            <SystemConnectionSnowflakeTables
                                connectionId={this.props.snowflakeConnection.connectionId}
                                onTableSelected={(preview) => {}}
                            ></SystemConnectionSnowflakeTables>
                        ) : this.props.getSnowflakeConnectionResult.success ? (
                            <MessageBox floating size="big" header="Connection not found.">
                                <p>The app you are looking for does not exist.</p>
                            </MessageBox>
                        ) : (
                            <></>
                        )
                    ) : (
                        <></>
                    );
                case "history":
                    return this.state.showHistory ? (
                        <SystemConnectionAudit connection={this.props.snowflakeConnection} onClose={this.cancelCreateConnection}></SystemConnectionAudit>
                    ) : (
                        <></>
                    );
                default:
                    return <ProhibitedArea></ProhibitedArea>;
            }
        } else if (this.props.connectionType === "salesforce") {
            switch (this.props.action.toLowerCase()) {
                case "create":
                    return (
                        <ManageSystemConnectionSalesforce
                            permission={this.props.permission}
                            action={this.props.action}
                            onSave={this.createSalesforceConnection}
                            onCancel={this.cancelCreateConnection}
                            formErrors={this.state.manageConnectionErrors}
                            onValuesChanged={this.onConnectionValuesChanged}
                        ></ManageSystemConnectionSalesforce>
                    );
                case "view":
                case "edit":
                    return !this.state.fetchingConnection ? (
                        this.props.salesforceConnection ? (
                            <>
                                <ManageSystemConnectionSalesforce
                                    permission={this.props.permission}
                                    action={this.props.action}
                                    onSave={this.updateSalesforceConnection}
                                    onCancel={this.cancelCreateConnection}
                                    connection={this.props.salesforceConnection}
                                    formErrors={this.state.manageConnectionErrors}
                                    onValuesChanged={this.onConnectionValuesChanged}
                                ></ManageSystemConnectionSalesforce>
                            </>
                        ) : this.props.getSalesforceConnectionResult.success ? (
                            <MessageBox floating size="big" header="Connection not found.">
                                <p>The app you are looking for does not exist.</p>
                            </MessageBox>
                        ) : (
                            <></>
                        )
                    ) : (
                        <></>
                    );
                case "history":
                    return this.state.showHistory ? (
                        <SystemConnectionAudit connection={this.props.salesforceConnection} onClose={this.cancelCreateConnection}></SystemConnectionAudit>
                    ) : (
                        <></>
                    );
                default:
                    return <ProhibitedArea></ProhibitedArea>;
            }
        } else if (this.props.connectionType === "hubspot") {
            switch (this.props.action.toLowerCase()) {
                case "create":
                    return (
                        <ManageSystemConnectionHubSpot
                            permission={this.props.permission}
                            action={this.props.action}
                            onSave={this.createHubspotConnection}
                            onCancel={this.cancelCreateConnection}
                            formErrors={this.state.manageConnectionErrors}
                            onValuesChanged={this.onConnectionValuesChanged}
                        ></ManageSystemConnectionHubSpot>
                    );
                case "view":
                case "edit":
                    return !this.state.fetchingConnection ? (
                        this.props.hubspotConnection ? (
                            <>
                                <ManageSystemConnectionHubSpot
                                    permission={this.props.permission}
                                    action={this.props.action}
                                    onSave={this.updateHubspotConnection}
                                    onCancel={this.cancelCreateConnection}
                                    connection={this.props.hubspotConnection}
                                    formErrors={this.state.manageConnectionErrors}
                                    onValuesChanged={this.onConnectionValuesChanged}
                                ></ManageSystemConnectionHubSpot>
                            </>
                        ) : this.props.getHubspotConnectionResult.success ? (
                            <MessageBox floating size="big" header="Connection not found.">
                                <p>The app you are looking for does not exist.</p>
                            </MessageBox>
                        ) : (
                            <></>
                        )
                    ) : (
                        <></>
                    );
                case "history":
                    return this.state.showHistory ? (
                        <SystemConnectionAudit connection={this.props.hubspotConnection} onClose={this.cancelCreateConnection}></SystemConnectionAudit>
                    ) : (
                        <></>
                    );
                default:
                    return <ProhibitedArea></ProhibitedArea>;
            }
        } else {
            return <></>;
        }
    };

    render() {
        return (
            <>
                <LoadingOverlay busy={this.isBusy()} spinner message={this.state.busyMessage || "Please wait..."}></LoadingOverlay>
                {!this.state.fetchingPermission ? this.getConnectionComponent() : <></>}
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        systemConnectionListResult: state.systemConnection.systemConnectionListResult,
        getSystemConnectionsResult: state.systemConnection.getSystemConnectionsResult,
        createConnectionResult: state.systemConnectionAwsS3.createConnectionResult,
        getConnectionResult: state.systemConnectionAwsS3.getConnectionResult,
        connection: state.systemConnectionAwsS3.connection,
        createdConnection: state.systemConnectionAwsS3.createdConnection,
        updateConnectionResult: state.systemConnectionAwsS3.updateConnectionResult,
        deleteConnectionResult: state.systemConnectionAwsS3.deleteConnectionResult,
        createJdbcConnectionResult: state.systemConnectionJdbc.createConnectionResult,
        getJdbcConnectionResult: state.systemConnectionJdbc.getConnectionResult,
        jdbcConnection: state.systemConnectionJdbc.connection,
        createdJdbcConnection: state.systemConnectionJdbc.createdConnection,
        updateJdbcConnectionResult: state.systemConnectionJdbc.updateConnectionResult,
        deleteJdbcConnectionResult: state.systemConnectionJdbc.deleteConnectionResult,
        createSnowflakeConnectionResult: state.systemConnectionSnowflake.createConnectionResult,
        getSnowflakeConnectionResult: state.systemConnectionSnowflake.getConnectionResult,
        snowflakeConnection: state.systemConnectionSnowflake.connection,
        createdSnowflakeConnection: state.systemConnectionSnowflake.createdConnection,
        updateSnowflakeConnectionResult: state.systemConnectionSnowflake.updateConnectionResult,
        deleteSnowflakeConnectionResult: state.systemConnectionSnowflake.deleteConnectionResult,
        createSalesforceConnectionResult: state.systemConnectionSalesforce.createConnectionResult,
        getSalesforceConnectionResult: state.systemConnectionSalesforce.getConnectionResult,
        salesforceConnection: state.systemConnectionSalesforce.connection,
        createdSalesforceConnection: state.systemConnectionSalesforce.createdConnection,
        updateSalesforceConnectionResult: state.systemConnectionSalesforce.updateConnectionResult,
        deleteSalesforceConnectionResult: state.systemConnectionSalesforce.deleteConnectionResult,
        startSalesforceOAuthResult: state.systemConnectionSalesforce.startOAuthResult,
        createHubspotConnectionResult: state.systemConnectionHubspot.createConnectionResult,
        getHubspotConnectionResult: state.systemConnectionHubspot.getConnectionResult,
        hubspotConnection: state.systemConnectionHubspot.connection,
        createdHubspotConnection: state.systemConnectionHubspot.createdConnection,
        updateHubspotConnectionResult: state.systemConnectionHubspot.updateConnectionResult,
        deleteHubspotConnectionResult: state.systemConnectionHubspot.deleteConnectionResult,
        startHubspotOAuthResult: state.systemConnectionHubspot.startOAuthResult,
        getSystemConnectionPermissionResult: state.systemConnection.getSystemConnectionPermissionResult,
        permission: state.systemConnection.userSystemConnectionPermission,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSystemConnectionPermission: () => dispatch(actions.getSystemConnectionPermissionRequest()),
        getSystemConnections: () => dispatch(actions.getSystemConnectionsRequest()),
        createAwsS3Connection: (connection) => dispatch(actions.createAwsS3ConnectionRequest(connection)),
        getAwsS3Connection: (connectionId) => dispatch(actions.getAwsS3ConnectionRequest(connectionId)),
        updateAwsS3Connection: (connectionId, updatedConnection) => dispatch(actions.updateAwsS3ConnectionRequest(connectionId, updatedConnection)),
        deleteAwsS3Connection: (connectionId) => dispatch(actions.deleteAwsS3ConnectionRequest(connectionId)),
        createJdbcConnection: (connection) => dispatch(actions.createJdbcConnectionRequest(connection)),
        getJdbcConnection: (connectionId) => dispatch(actions.getJdbcConnectionRequest(connectionId)),
        updateJdbcConnection: (connectionId, updatedConnection) => dispatch(actions.updateJdbcConnectionRequest(connectionId, updatedConnection)),
        deleteJdbcConnection: (connectionId) => dispatch(actions.deleteJdbcConnectionRequest(connectionId)),
        createSnowflakeConnection: (connection) => dispatch(actions.createSnowflakeConnectionRequest(connection)),
        getSnowflakeConnection: (connectionId) => dispatch(actions.getSnowflakeConnectionRequest(connectionId)),
        updateSnowflakeConnection: (connectionId, updatedConnection) => dispatch(actions.updateSnowflakeConnectionRequest(connectionId, updatedConnection)),
        deleteSnowflakeConnection: (connectionId) => dispatch(actions.deleteSnowflakeConnectionRequest(connectionId)),
        createSalesforceConnection: (connection) => dispatch(actions.createSalesforceConnectionRequest(connection)),
        getSalesforceConnection: (connectionId) => dispatch(actions.getSalesforceConnectionRequest(connectionId)),
        updateSalesforceConnection: (connectionId, updatedConnection) => dispatch(actions.updateSalesforceConnectionRequest(connectionId, updatedConnection)),
        deleteSalesforceConnection: (connectionId) => dispatch(actions.deleteSalesforceConnectionRequest(connectionId)),
        startSalesforceOAuth: (connectionId, returnUrl) => dispatch(actions.startSalesforceOAuthRequest(connectionId, returnUrl)),
        createHubspotConnection: (connection) => dispatch(actions.createHubspotConnectionRequest(connection)),
        getHubspotConnection: (connectionId) => dispatch(actions.getHubspotConnectionRequest(connectionId)),
        updateHubspotConnection: (connectionId, updatedConnection) => dispatch(actions.updateHubspotConnectionRequest(connectionId, updatedConnection)),
        deleteHubspotConnection: (connectionId) => dispatch(actions.deleteHubspotConnectionRequest(connectionId)),
        startHubspotOAuth: (connectionId, returnUrl) => dispatch(actions.startHubspotOAuthRequest(connectionId, returnUrl)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SystemConnections));
